import OnboardingLayer from './OnboardingLayer';
export default OnboardingLayer;
